const wjf2019Style = [
  {
    'featureType': 'all',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#50019a',
      },
      {
        'weight': '1.20',
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'weight': '1.00',
      },
    ],
  },
  {
    'featureType': 'administrative.country',
    'elementType': 'geometry',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative.province',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'all',
    'stylers': [
      {
        'color': '#ead5ff',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#50019a',
      },
    ],
  },
  {
    'featureType': 'landscape.natural.landcover',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape.natural.terrain',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'poi',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'poi.attraction',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.attraction',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#7e05ff',
      },
    ],
  },
  {
    'featureType': 'poi.business',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.business',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#460091',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#c792ff',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#460091',
      },
    ],
  },
  {
    'featureType': 'poi.school',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.school',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#460091',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': -100,
      },
      {
        'lightness': 45,
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#e1c5ff',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#50019a',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'weight': '0.80',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'simplified',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#e0c3ff',
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#c58eff',
      },
      {
        'weight': '1.00',
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'hue': '#7b00ff',
      },
      {
        'saturation': '100',
      },
      {
        'lightness': '-10',
      },
      {
        'gamma': '0.70',
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'weight': '0.80',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ead5ff',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#e1c5ff',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#50019a',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'hue': '#7b00ff',
      },
    ],
  },
  {
    'featureType': 'transit.line',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'transit.line',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#8c19f8',
      },
    ],
  },
  {
    'featureType': 'water',
    'elementType': 'all',
    'stylers': [
      {
        'color': '#ba79ff',
      },
      {
        'visibility': 'on',
      },
    ],
  },
];

const wjf2020Style = [
  {
    'featureType': 'all',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#b2007c',
      },
      {
        'weight': '1.20',
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'weight': '1.00',
      },
    ],
  },
  {
    'featureType': 'administrative.country',
    'elementType': 'geometry',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative.province',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'all',
    'stylers': [
      {
        'color': '#ff8cdd',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#b2007c',
      },
    ],
  },
  {
    'featureType': 'landscape.natural.landcover',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape.natural.terrain',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'poi',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'poi.attraction',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.attraction',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#fe00b2',
      },
    ],
  },
  {
    'featureType': 'poi.business',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.business',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#e75bbd',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#e75bbd',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#e75bbd',
      },
    ],
  },
  {
    'featureType': 'poi.school',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.school',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#e75bbd',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': -100,
      },
      {
        'lightness': 45,
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#fed5f2',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#b2007c',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'weight': '0.80',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'simplified',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#fed5f2',
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#ec56bf',
      },
      {
        'weight': '1.00',
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'hue': '#ff00b3',
      },
      {
        'saturation': '100',
      },
      {
        'lightness': '-10',
      },
      {
        'gamma': '0.70',
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'weight': '0.80',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ff8cdd',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#e1c5ff',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#b2007c',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'hue': '#fe00b2',
      },
    ],
  },
  {
    'featureType': 'transit.line',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'transit.line',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#da159f',
      },
    ],
  },
  {
    'featureType': 'water',
    'elementType': 'all',
    'stylers': [
      {
        'color': '#fe69d1',
      },
      {
        'visibility': 'on',
      },
    ],
  },
];

const nzf2020Style = [
  {
    'featureType': 'all',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'saturation': 36,
      },
      {
        'color': '#333333',
      },
      {
        'lightness': 40,
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'visibility': 'on',
      },
      {
        'color': '#ffffff',
      },
      {
        'lightness': 16,
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#fefefe',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#fefefe',
      },
      {
        'lightness': 17,
      },
      {
        'weight': 1.2,
      },
    ],
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5',
      },
      {
        'lightness': 21,
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#dedede',
      },
      {
        'lightness': 21,
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 17,
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 29,
      },
      {
        'weight': 0.2,
      },
    ],
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 18,
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 16,
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f2f2f2',
      },
      {
        'lightness': 19,
      },
    ],
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': window.THEME_COLORS.light,
      },
      {
        'lightness': 17,
      },
    ],
  },
];

const nzf2022Style = [
  {
    'featureType': 'all',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'saturation': 36,
      },
      {
        'color': '#333333',
      },
      {
        'lightness': 40,
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'visibility': 'on',
      },
      {
        'color': '#ffffff',
      },
      {
        'lightness': 16,
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#fefefe',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#fefefe',
      },
      {
        'lightness': 17,
      },
      {
        'weight': 1.2,
      },
    ],
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5',
      },
      {
        'lightness': 21,
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#dedede',
      },
      {
        'lightness': 21,
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 17,
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 29,
      },
      {
        'weight': 0.2,
      },
    ],
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 18,
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 16,
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f2f2f2',
      },
      {
        'lightness': 19,
      },
    ],
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': window.THEME_COLORS.light,
      },
      {
        'lightness': 17,
      },
    ],
  },
];

const lsq2020Style = [
  {
    'featureType': 'all',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'saturation': 36,
      },
      {
        'color': '#333333',
      },
      {
        'lightness': 40,
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'visibility': 'on',
      },
      {
        'color': '#ffffff',
      },
      {
        'lightness': 16,
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#fefefe',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#fefefe',
      },
      {
        'lightness': 17,
      },
      {
        'weight': 1.2,
      },
    ],
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5',
      },
      {
        'lightness': 21,
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#dedede',
      },
      {
        'lightness': 21,
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 17,
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 29,
      },
      {
        'weight': 0.2,
      },
    ],
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 18,
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 16,
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f2f2f2',
      },
      {
        'lightness': 19,
      },
    ],
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#a18455',
      },
      {
        'lightness': 17,
      },
    ],
  },
];

const tha2022Style = [
  {
    'featureType': 'all',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'weight': '1.20',
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'color': '#333132',
      },
      {
        'weight': '1.00',
      },
    ],
  },
  {
    'featureType': 'administrative.country',
    'elementType': 'geometry',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative.province',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'all',
    'stylers': [
      {
        'color': '#4C86A1',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
    ],
  },
  {
    'featureType': 'landscape.natural.landcover',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape.natural.terrain',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'poi',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'poi.attraction',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.attraction',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#4e7e91',
      },
    ],
  },
  {
    'featureType': 'poi.business',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'poi.business',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#4e7e91',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#2E5161',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#4e7e91',
      },
    ],
  },
  {
    'featureType': 'poi.school',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'poi.school',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'color': '#4e7e91',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': -100,
      },
      {
        'lightness': 45,
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#5190AD',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
    ],
  },
  {
    'featureType': 'road',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'weight': '0.80',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'simplified',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#5190AD',
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#2E5161',
      },
      {
        'weight': '1.00',
      },
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'hue': '#2E5161',
      },
      {
        'saturation': '100',
      },
      {
        'lightness': '-10',
      },
      {
        'gamma': '0.70',
      },
    ],
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#407087',
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#407087',
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'weight': '0.80',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#407087',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#407087',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'hue': '#2E5161',
      },
    ],
  },
  {
    'featureType': 'transit.line',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on',
      },
    ],
  },
  {
    'featureType': 'transit.line',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#2E5161',
      },
    ],
  },
  {
    'featureType': 'water',
    'elementType': 'all',
    'stylers': [
      {
        'color': '#6FC5ED',
      },
      {
        'visibility': 'on',
      },
    ],
  },
];

const twh2023Style = [
  {
    'featureType': 'all',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'saturation': 36,
      },
      {
        'color': '#333333',
      },
      {
        'lightness': 40,
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'visibility': 'on',
      },
      {
        'color': '#ffffff',
      },
      {
        'lightness': 16,
      },
    ],
  },
  {
    'featureType': 'all',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#fefefe',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#fefefe',
      },
      {
        'lightness': 17,
      },
      {
        'weight': 1.2,
      },
    ],
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'featureType': 'landscape',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5',
      },
      {
        'lightness': 21,
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#dedede',
      },
      {
        'lightness': 21,
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 17,
      },
    ],
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 29,
      },
      {
        'weight': 0.2,
      },
    ],
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 18,
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff',
      },
      {
        'lightness': 16,
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f2f2f2',
      },
      {
        'lightness': 19,
      },
    ],
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': window.THEME_COLORS.light,
      },
      {
        'lightness': 17,
      },
    ],
  },
];


export default {
  'lsq_2020': lsq2020Style,
  'nzf_2020': nzf2020Style,
  'nzf_2022': nzf2022Style,
  'wjf_2019': wjf2019Style,
  'wjf_2020': wjf2020Style,
  'tha_2022': tha2022Style,
  'twh_2023': twh2023Style,
};
